/* eslint-disable react/prop-types */
import React from 'react';

// PreviewImage Component
const PostPreviewImage = ({ imageUrl, layout }) => {
  const imageClasses =
    layout === 'story' ? 'w-full h-full object-cover rounded-lg' : 'w-full h-auto object-contain';

  return (
    <div
      className={
        layout === 'story'
          ? 'flex-1 w-full overflow-hidden flex items-center justify-center min-h-0'
          : 'w-full overflow-hidden flex items-center justify-center'
      }
      style={{
        ...(layout === 'feed' ? { aspectRatio: '1/1' } : undefined),
        background: layout === 'feed' ? '#fafafa' : undefined,
      }}
    >
      <img
        src={imageUrl}
        alt='Preview image'
        className={imageClasses}
        onError={(e) => {
          e.target.src = 'https://placehold.co/600x600/png?text=No+Image';
        }}
      />
    </div>
  );
};

export default PostPreviewImage;
